import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { CxbDatePipe } from '../../pipes/cxb-date.pipe';

@Component({
  selector: 'osn-cxb-readonly-timezone-input',
  templateUrl: './readonly-timezone-input.component.html',
  styleUrls: ['./readonly-timezone-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadonlyTimezoneInputComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public label: string;
  @Input() public control: FormControl;

  public value = 'dd/mm/yyyy, --:--';

  private readonly destroyed$ = new Subject<void>();
  private subscription: Subscription;

  constructor(private readonly cdr: ChangeDetectorRef, private readonly datePipe: CxbDatePipe) {}

  public ngOnInit(): void {
    this.trackCurrentControlValueChanges();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['control'] && !changes['control'].isFirstChange()) {
      this.trackCurrentControlValueChanges();
    }
  }

  private trackCurrentControlValueChanges() {
    this.subscription?.unsubscribe();
    this.subscription = this.control.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
      if (this.control.valid || this.control.disabled) {
        this.value = this.datePipe.transform(new Date(value), 'dd/MM/yyyy, hh:mm a', 'GMT+3');
      } else {
        this.value = 'dd/MM/yyyy, --:--';
      }
      this.cdr.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
